import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=56e03716&scoped=true&"
import script from "./Package.vue?vue&type=script&lang=ts&"
export * from "./Package.vue?vue&type=script&lang=ts&"
import style0 from "./Package.vue?vue&type=style&index=0&id=56e03716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e03716",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
